import { render } from "./StartDateView.vue?vue&type=template&id=66cef2a4"
import script from "./StartDateView.vue?vue&type=script&lang=js"
export * from "./StartDateView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__